import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

function ImportIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.24 7.11639L10.7778 5.65417V12.3975C10.7778 12.8253 10.4278 13.1753 9.99998 13.1753C9.57221 13.1753 9.22221 12.8253 9.22221 12.3975V5.65417L7.75221 7.11639C7.44887 7.41972 6.95887 7.41972 6.65554 7.11639C6.5099 6.97108 6.42805 6.77379 6.42805 6.56806C6.42805 6.36232 6.5099 6.16504 6.65554 6.01972L9.44776 3.2275C9.7511 2.92417 10.2411 2.92417 10.5444 3.2275L13.3367 6.01972C13.64 6.32306 13.64 6.81306 13.3367 7.11639C13.0333 7.41972 12.5433 7.41972 12.24 7.11639ZM15.4444 14.6667V10.7778C15.4444 10.35 15.7944 9.99998 16.2222 9.99998C16.65 9.99998 17 10.35 17 10.7778V15.4444C17 16.3 16.3 17 15.4444 17H4.55556C3.7 17 3 16.3 3 15.4444V10.7778C3 10.35 3.35 9.99998 3.77778 9.99998C4.20556 9.99998 4.55556 10.35 4.55556 10.7778V14.6667C4.55556 15.0944 4.90556 15.4444 5.33333 15.4444H14.6667C15.0944 15.4444 15.4444 15.0944 15.4444 14.6667Z"
      />
    </SvgIcon>
  );
}

export default ImportIcon;
